import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

const TITLE_INPUT_WIDTH = "220px";

export const useVaultMeetingsFilterBandStyles = makeStyles({
  root: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: designTokens.spacing[2],
    padding: `${designTokens.spacing[2]} ${designTokens.spacing[3]}`,
    backgroundColor: projectIqTokens.tealSoft,
    border: `1px solid ${projectIqTokens.tealLine}`,
    borderRadius: designTokens.borderRadius.lg,
  },
  label: {
    fontSize: designTokens.fontSize["2xs"],
    fontWeight: designTokens.fontWeight.bold,
    color: projectIqTokens.tealInk,
  },
  titleInput: {
    width: TITLE_INPUT_WIDTH,
    maxWidth: "100%",
  },
  clearButton: {
    color: projectIqTokens.muted,
    fontWeight: designTokens.fontWeight.semibold,
  },
  spacer: {
    flex: 1,
  },
  count: {
    fontSize: designTokens.fontSize.xs,
    color: projectIqTokens.muted,
  },
});
